import { createContext, useContext, useMemo, type PropsWithChildren, type ReactNode } from 'react'

import { useTranslate } from '@/src/lang/useTranslate'

import { makeRoutes } from '../../constants/routes'

type TRoutes = ReturnType<typeof makeRoutes>

const RoutesContext = createContext({
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- context default placeholder
  routes: {} as TRoutes,
})

export const RoutesProvider = ({ children, lang }: PropsWithChildren<{ lang: string }>): ReactNode => {
  const { t } = useTranslate()
  const value = useMemo(() => ({ routes: makeRoutes(lang, t) }), [lang, t])
  return <RoutesContext.Provider value={value}>{children}</RoutesContext.Provider>
}

export const useRoutes = () => {
  return useContext(RoutesContext)
}
